<template>
  <card header='Donat'>
    <svg-donut class="w5" :series="series"></svg-donut>
  </card>
</template>

<script>
import Card from './Card.vue'
import SvgDonut from '@/components/charts/svg/Donut.vue'

export default {
  components: {
    Card,
    SvgDonut
  },
  data () {
    return {
      series: {
        hole: [{
          text: 'всего',
          value: (data) => data.reduce((sum, { value }) => { return sum + value }, 0),
          unit: 'шт'
        }],
        data: [
          {
            label: 'Скубатова Елена Владимировна',
            value: 1607052593
          },
          {
            label: 'Торопова Екатерина Юрьевна',
            value: 166370998
          },
          {
            label: 'Лазарева Марина Николаевна',
            value: 136470006
          },
          {
            label: 'Рыбникова Татьяна Юрьевна',
            value: 64180077
          },
          {
            label: 'Воронович Галина Юрьевна',
            value: 60048814
          },
          {
            label: 'Коннова Ирина Вячеславовна',
            value: 55712246
          },
          {
            label: 'Седова Евгения Владимировна',
            value: 15800235
          },
          {
            label: 'Ласточкина Елена Валерьевна',
            value: 13417091
          },
          {
            label: 'Кубинцева Елена Александровна',
            value: 13300107
          },
          {
            label: 'Елагин Михаил Владимирович',
            value: 2046241
          },
          {
            label: 'Кучеренко Евгений Дмитриевич',
            value: 1887692
          },
          {
            label: 'Метропольская Ольга Евгеньевна',
            value: 1778057
          },
          {
            label: 'Соловьева Анна Серьгеевна',
            value: 951934
          },
          {
            label: 'Мартынов Кирилл Константинович',
            value: 928767
          }
        ]
      },
      series2: {
        hole: [{
          text: 'всего',
          value: (data) => data.reduce((sum, { value }) => { return sum + value }, 0),
          unit: 'шт.'
        }],
        data: [
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 },
          { value: 10 }
        ]
      }
    }
  }
}
</script>
